const circleImageModal = () => {
  if (document.querySelectorAll(".circle-image-modal-section").length < 1) {
    return;
  }

  const modal = document.querySelectorAll(".modal-container");
  const modalCount = modal.length;
  const modalOpenButton = document.querySelectorAll(".circle-image-single__button");
  const modalOpenButtonCount = modalOpenButton.length;
  const modalCloseButton = document.querySelectorAll(".modal-close-button");
  const modalCloseButtonCount = modalCloseButton.length;

  for(let i = 0; i < modalOpenButtonCount; i++) {
    modalOpenButton[i].addEventListener("click", () => {
      if(modal[i].classList.contains("active")) {
        modal[i].classList.remove("active");
      } else {
        modal[i].classList.add("active");
        document.body.classList.add('overflow-hidden');
      }
    });
  }
  for(let i = 0; i < modalCloseButtonCount; i++) {
    modalCloseButton[i].addEventListener("click", () => {
      modal[i].classList.remove("active");
      document.body.classList.remove('overflow-hidden');
    });
  }
  for(let i = 0; i < modalCount; i++) {
    if(modal[i].classList.contains("active")) {
      window.addEventListener("click", (e) => {
        console.log(e.target);
        if(e.target !== modal[i]) {
          modal[i].classList.remove("active");
        }
      });
    }
  }
};

export default circleImageModal;
